import $ from "jquery";
import { dataaccess } from "../dataaccess/dataContext";

let data;
let params;

function init() {
    $(document).on("click", ".expire-role-btn", function() {
        data = $(this).parent().children(".active-role-id").val();

        params = {
            "data": data,
            "url": "/Person/ExpireRole"
        };

        dataaccess.post(params).done(function(results) {
            location.reload();
        });
    });
}

export const expireRole = {
    init: init
};